import React from 'react';
import CurriculumTemplate from '../../components/template-curriculum';
import { getProp, getPropRel } from '../utils';

const CurriculumPreview = (props) => {
  const title = getProp(props, 'title');
  const subtitle = getProp(props, 'subtitle');
  const experiences = getPropRel(props, 'experiences', 'experience');
  const formationSubtitle = getProp(props, 'formationSubtitle');
  const formationExperiences = getPropRel(props, 'formationExperiences', 'experience');

  return (
    <CurriculumTemplate
      data={{ title, subtitle, experiences, formationSubtitle, formationExperiences }}
    />
  );
};

export default CurriculumPreview;
